import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxCallbackOption, OnyxColor } from '@onyx/angular';
import {
  OnyxBadgeComponent,
  OnyxButtonComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import type { Delegation } from '../../common/interfaces/delegation';

@Component({
  selector: 'app-delegation-modal-header-description',
  imports: [
    TranslatePipe,
    OnyxButtonComponent,
    OnyxTooltipDirective,
    OnyxBadgeComponent,
  ],
  templateUrl: './delegation-modal-header-description.component.html',
  styleUrl: './delegation-modal-header-description.component.scss',
})
export class DelegationModalHeaderDescriptionComponent {
  public readonly delegation = input.required<Delegation>();
  public readonly actionButton = input.required<OnyxCallbackOption | null>();

  protected readonly DictionaryCode = DictionaryCode;

  protected status = computed(() => ({
    name: this.delegation().status.value,
    color: `light-${this.delegation().status.color}` as OnyxColor,
  }));
}
